<ng-template #reviewPopup let-modal>
  <!-- Event Favorite Section -->
  <button class="ms-auto me-4 mt-3 btn-favorite-wrapper {{ readonly ? 'btn-favorite-wrapper-disabled' : '' }}"
    [disabled]="readonly" (click)="toggleFavoriteEventState()">
    <i aria-hidden="true" class="btn-favorite fa {{ popupData.favorite ? 'fa-heart' : 'fa-heart-o' }} fs-3"
      data-toggle="tooltip" data-placement="top"
      title="{{ popupData.favorite ? 'Remove from Favorites' : 'Add to Favorites' }}"></i>
  </button>

  <!-- Event Image -->
  <div class="modal-image">
    <img src="{{popupData.eventImage}}" alt="Event Banner">
    <p class="fs-5 mb-0 ml-auto mr-auto mt-2">{{popupData.name + ': ' + popupData.eventType}}</p>
    <span class="event-date d-flex justify-content-center fw-normal">Attended: {{eventPurchaseTime || '--'}}</span>
  </div>

  <!-- Event Description -->
  <div class="modal-body" *ngIf="contentType === 'DESCRIPTION' && !showReviewForm">
    <p class="fw-bold">Description</p>
    <p>
      {{shortContent}}
      <span type="button" class="btn-toggle-content" (click)="toggleContentSize()">{{shortContent !== content ? 'Show
        More' : 'Show Less'}}</span>
    </p>
  </div>

  <!-- Event Review Rating - NEW & EDIT -->
  <div *ngIf="popupData.review || showReviewForm" class="mt-2 d-flex flex-row justify-content-center align-items-center"
    [formGroup]="getFormGroup()">
    <span class="me-2">Personal Rating</span>
    <ng-template #stars let-fill="fill">
      <span class="star" [class.full]="fill === 100">
        <span class="half" [style.width.%]="fill">&#9733;</span>&#9733;
      </span>
    </ng-template>
    <ngb-rating class="ml-4" [max]="5" [starTemplate]="stars" formControlName="rating"
      (ngModelChange)="enableReviewEdit()"></ngb-rating>
  </div>

  <!-- Event Review Thoughts - EDIT -->
  <div *ngIf="popupData.review" class="d-flex flex-column align-items-flex-start mb-3" [formGroup]="getFormGroup()">
    <p class="fw-bold ms-4 mb-0">Thoughts</p>
    <p *ngIf="!showReviewForm" class="mb-0 ms-4 review-text">{{popupData.review.review}}</p>
    <textarea *ngIf="showReviewForm" id="reviewText" class="review-input rounded-3 mx-auto my-2"
      placeholder="Your thoughts here..." maxlength="4096" formControlName="review"></textarea>
  </div>

  <!-- Event Review Thoughts - NEW -->
  <div *ngIf="!popupData.review && showReviewForm" class="d-flex mb-4" [formGroup]="getFormGroup()">
    <textarea id="reviewText" class="review-input rounded-3 mx-auto my-2" placeholder="Your thoughts..."
      maxlength="4096" formControlName="review"></textarea>
  </div>

  <div class="popup-footer ps-0 pe-0" *ngIf="eventType">

    <!-- No Event Review Actions -->
    <section class="d-flex flex-row align-items-center w-100 justify-content-end" *ngIf="contentType === 'DESCRIPTION'">
      <button *ngIf="!readonly && !showReviewForm" class="btn btn-write-review" (click)="toggleReviewForm()">
        Write a Review
      </button>
      <button *ngIf="!readonly && showReviewForm" class="btn btn-write-review btn-edit-review"
        (click)="toggleReviewForm()">
        Cancel
      </button>
      <button *ngIf="!readonly && showReviewForm" (click)="publishPopupData()" class="ms-4 btn btn-write-review">
        Submit Review
      </button>
    </section>

    <!-- Existing Event Review Actions -->
    <section class="d-flex flex-row align-items-center w-100" *ngIf="contentType === 'REVIEW'">
      <span class="me-4 fw-bold">{{ votesMessage }}</span>
      <button class="ps-0 btn btn-vote btn-upvote d-flex flex-column align-items-center justify-content-center"
        (click)="toggleUpvote()">
        <i aria-hidden="true" class="fa fa-chevron-up" [ngClass]="getVoteStateCSS('UPVOTE')"></i>
        <span>{{upvoteCount}}</span>
      </button>
      <button class="ps-0 btn btn-vote btn-downvote d-flex flex-column align-items-center justify-content-center"
        (click)="toggleDownvote()">
        <i aria-hidden="true" class="fa fa-chevron-down" [ngClass]="getVoteStateCSS('DOWNVOTE')"></i>
        <span>{{downvoteCount}}</span>
      </button>
      <button *ngIf="!readonly && !showReviewForm"
        class="btn btn-write-review {{showReviewForm ? '' : 'btn-edit-review'}}" (click)="toggleReviewForm()">
        <i aria-hidden="true" class="fa fa-edit"></i>
      </button>
      <button *ngIf="!readonly && showReviewForm" class="btn btn-write-review btn-edit-review"
        (click)="toggleReviewForm()">
        Cancel
      </button>
      <button *ngIf="!readonly && showReviewForm" class="ms-4 btn btn-write-review" (click)="publishPopupData()">
        Submit Review
      </button>
    </section>
  </div>
</ng-template>
